import { Controller } from '@hotwired/stimulus'

// Simple dropdown controller for user menus
export default class extends Controller {
  static targets = ['trigger', 'menu']

  connect() {
    // Close dropdown when clicking outside
    this.boundClickOutside = this.clickOutside.bind(this)
    document.addEventListener('click', this.boundClickOutside)
  }

  disconnect() {
    document.removeEventListener('click', this.boundClickOutside)
  }

  toggle(event) {
    event.stopPropagation()
    const isOpen = !this.menuTarget.classList.contains('hidden')

    if (isOpen) {
      this.close()
    } else {
      this.open()
    }
  }

  open() {
    this.menuTarget.classList.remove('hidden')
    this.triggerTarget.setAttribute('aria-expanded', 'true')
  }

  close() {
    this.menuTarget.classList.add('hidden')
    this.triggerTarget.setAttribute('aria-expanded', 'false')
  }

  clickOutside(event) {
    if (!this.element.contains(event.target)) {
      this.close()
    }
  }
}
